const ZOHO = window.ZOHO;

export async function getCrmUsersSignature({ email }) {
  // const loggedinUserResp = await ZOHO.CRM.CONFIG.getCurrentUser();
  try {
    const userResp = await ZOHO.CRM.API.searchRecord({
      Entity: "users",
      Type: "criteria",
      Query: `(email:equals:${email})`,
    });
    const userId = await userResp?.users?.[0]?.id;
    if (userId) {
      const userDetailsResp = await ZOHO.CRM.API.getUser({ ID: userId });
      const userSign = await userDetailsResp?.users?.[0]?.signature;
      return { data: userSign, error: null };
    } else {
      return { data: null, error: "Something went wrong" };
    }

    // const corrected = await userSign.replace(
    //   "<br>",
    //   "<br/>"
    // );
  } catch (getCrmUsersSignatureError) {
    return { data: null, error: "Something went wrong" };
  }
}

export async function getCrmUsersEmail({ accessToken, dataCenterUrl }) {
  try {
    const url = `${dataCenterUrl}/crm/v6/settings/emails/actions/from_addresses`;
    var req_data = {
      url,
      param_type: 1,
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };

    const resp = await ZOHO.CRM.HTTP.get(req_data);
    const parsedResp = await JSON.parse(resp);

    const allowedEmails = await parsedResp?.from_addresses
      ?.filter((el) => el.type === "org_email")
      ?.map((el) => el?.email);

    return { data: allowedEmails, error: null };
  } catch (getCrmUsersEmailError) {

    return { data: null, error: "Your organization has no approved email" };
  }
}

export async function getAllowedEmails({ accessToken, dataCenterUrl }) {
  try {
    const url = `${dataCenterUrl}/crm/v7/settings/emails/actions/from_addresses`;
    var req_data = {
      url,
      param_type: 1,
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };

    const resp = await ZOHO.CRM.HTTP.get(req_data);
    const parsedResp = await JSON.parse(resp);

    const allowedEmails = await parsedResp?.from_addresses?.map(
      (el) => el?.email
    );

    return { data: [...new Set(allowedEmails)], error: null };
  } catch (getAllowedEmailsError) {

    return { data: null, error: "Something went wrong" };
  }
}

export const user = {
  getCrmUsersEmail,
  getCrmUsersSignature,
  getAllowedEmails,
};
